<template>
  <div class="page">
    <div class="hero">
      <div>
        <div class="hello">欢迎回来，{{ home.user.nickname || '用户' }}</div>
        <div class="hero-sub">签约状态 <span class="pill ok" v-if="home.hasSigned">已签约</span><span class="pill" v-else>未签约</span></div>
        <div class="device-line">设备 SN：{{ device.sn || '未绑定' }} ｜ <span :class="device.status==='ONLINE'?'green':'gray'">{{ device.status==='ONLINE'?'在线':'离线' }}</span><small v-if="lastRefresh"> · {{lastRefresh}}刷新</small></div>
        <div class="device-line">签约人：{{ home.hasSigned ? (home.signerName || home.user.nickname || '客户') : '未签约' }}</div>
        <div class="device-line">签约日期：{{ home.signDate || '未签约' }}</div>
        <div class="muted" v-if="device.offline_reason">离线原因：{{ device.offline_reason }}</div>
      </div>
      <button class="btn" @click="bind">机具绑定</button>
    </div>

    <div class="money-grid">
      <div class="metric"><div class="muted">待提现</div><div class="money">¥{{ money(home.signedAmount || home.withdrawable || 0) }}</div></div>
      <div class="metric"><div class="muted">已达标</div><div class="money">{{ money(home.achievedAmount || home.pending || 0) }}/780</div><p>每月达标 +32.5</p></div>
      <div class="metric"><div class="muted">已提现</div><div class="money">¥{{ money(home.paid || 0) }}</div></div>
    </div>

    <div class="education-showcase">
      <div class="section-kicker">EDU BENEFIT</div>
      <div class="edu-title-row">
        <div>
          <h2>{{ content.education_benefit.title || '九学王·正版同步课堂权益' }}</h2>
          <p>正版 K12 同步教育资源，设备绑定成功即可免费使用。</p>
        </div>
      </div>
      <div class="story-grid">
        <div class="story-block story-img">
          <div class="edu-visual">
            <img src="/edu/jiuxuewang-company.webp" alt="九学王企业介绍">
          </div>
        </div>
        <div class="story-block story-copy">
          <div class="edu-copy">
            <h3>课程内容提供方</h3>
            <p><b>九学王教育</b></p>
            <p>集团 2014 年起源深圳，2020 年落户合肥，智慧教育解决方案输出的科创企业。布局深圳产研、北京教研、武汉录播、上海云平台，打造九学网 / 学王课堂核心教育品牌，深耕中小学正版同步教育资源十余年。</p>
            <h3>企业权威资质（资质归属：九学王教育）</h3>
            <div class="cert-grid">
              <span>国家高新技术企业</span>
              <span>海量课程视频自主著作权</span>
              <span>全部课程内容自有版权</span>
              <span>正版源头，规避版权侵权风险</span>
              <span>合肥市重点招商引资科创企业</span>
              <span>近 300 人全职教研团队</span>
            </div>
          </div>
        </div>
        <div class="story-block story-img">
          <div class="edu-visual course-screen">
            <img src="/edu/jiuxuewang-courses.webp" alt="九学网同步课堂课程页面">
          </div>
        </div>
        <div class="story-block story-copy">
          <div class="course-copy">
            <h3>九学王同步课堂产品介绍</h3>
            <p>九学王同步课堂覆盖小学、初中、高中全学段、全学科，适配全国主流教材版本（人教版、苏教版、北师大版、外研版等）。</p>
            <ul>
              <li>课前预习：名师梳理新知，提前吃透课堂重点</li>
              <li>课堂同步：一线骨干教师真人视频授课，紧跟校内教学进度</li>
              <li>课后复习：知识点精讲、难点拆解、典型例题讲解</li>
              <li>配套拓展：课本点读、专项微课、考点总结、习题解析</li>
            </ul>
            <p>课程贴合校内课标，纯同步学习内容，满足学生课前预习、课后查漏补缺、假期知识巩固需求，助力家庭开展居家自主学习。课程资源支持学习盒子、智能终端、APP 多场景合法搭载，软硬件融合应用模式。</p>
            <div class="tag-list"><span v-for="tag in educationTags" :key="tag">{{ tag }}</span></div>
          </div>
        </div>
      </div>
      <div v-if="content.education_benefit.content" class="admin-rich">
        <div class="rich-content" v-html="content.education_benefit.content"></div>
      </div>
    </div>
</div></template>
<script>
import { api, getUserId, ensureLogin } from '../api'
export default {
  data:()=>({home:{user:{},device:{}}, sn:'', content:{education_benefit:{}},lastRefresh:'',refreshTimer:null}),
  computed:{device(){return this.home.device||{}}, educationTags(){try{return JSON.parse(this.content.education_benefit.extra_json||'[]')}catch(e){return []}}},
  async created(){
    await this.loadContent()
    const params=new URLSearchParams(location.search)
    if(params.get('code')){
      try{
        await ensureLogin()
        await this.load()
        const target=sessionStorage.getItem('oauthReturnPath')
        if(target&&target!=='/'){sessionStorage.removeItem('oauthReturnPath');this.$router.replace(target);return}
      }catch(e){alert((e.response&&e.response.data&&e.response.data.message)||e.message||'微信授权登录失败')}
    }else await this.load()
    if(this.device.sn)localStorage.setItem('deviceSn',this.device.sn)
    this.refreshTimer=setInterval(()=>this.refreshStatus(false),30000);document.addEventListener('visibilitychange',this.onVisible)
  },
  beforeDestroy(){clearInterval(this.refreshTimer);document.removeEventListener('visibilitychange',this.onVisible)},
  methods:{
    async loadContent(){ const rows=(await api.get('/h5/content-config')).data.data; rows.forEach(x=>this.$set(this.content,x.config_key,x)) },
    async load(){ this.home=(await api.get('/h5/home',{params:{userId:getUserId()}})).data.data },
    async refreshStatus(showError){try{const r=(await api.post('/h5/dashboard/refresh',{},{params:{includeLedger:false}})).data.data||{};this.lastRefresh=(r.refreshedAt||'').slice(11,16);await this.load();if(this.device.sn)localStorage.setItem('deviceSn',this.device.sn)}catch(e){if(showError)alert((e.response&&e.response.data&&e.response.data.message)||'设备状态刷新失败')}},
    onVisible(){if(document.visibilityState==='visible')this.refreshStatus(false)},
    money(v){ return Number(v || 0).toFixed(2).replace('.00','') },
    async bind(){ const uid=await ensureLogin(); if(!uid)return; this.$router.push('/bind-device') }
  }
}
</script>
<style scoped></style>
